import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import VendorHeader from "../component/VendorHeader";
import VendorFooter from "../component/VendorFooter";
import Sidebar from "../component/Sidebar";

import { API_BASE_URL } from "../utils/app_url";
import { useLanguage } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";

const OrderDetails = () => {
  const { user } = useAuth();
  const { langJson } = useLanguage();
  const navigate = useNavigate();
  const { orderId } = useParams();

  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState(null); // ✅ normalized

  /* =========================
     FETCH ORDER DETAILS
  ========================= */
  const fetchOrderDetails = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${API_BASE_URL}order/store-orders/${orderId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.authorisation?.token}`,
          },
        }
      );

      const res = await response.json();

      if (res?.res === true) {
        setOrder(res.data);
      } else {
        setOrder(null);
      }
    } catch (err) {
      console.error("Fetch order details failed", err);
      setOrder(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user && orderId) {
      fetchOrderDetails();
    }
  }, [user, orderId]);

  const currency = order?.currency ?? "₹";

  /* =========================
     RENDER
  ========================= */
  return (
    <>
      <VendorHeader />

      <div className="adminDash">
        <Sidebar />

        <div className="orderRgt">
          <h2>{langJson?.orderdetails || "Order Details"}</h2>

          {!loading && order && (
            <div className="orderRgtMain">
              {/* LEFT SIDE */}
              <div className="orLft">
                <ul>
                  <li>
                    <label>{langJson?.orderno}</label>
                    {order?.order_number}
                  </li>
                  <li>
                    <label>{langJson?.orderdate}</label>
                    {order?.ordered_date || "-"}
                  </li>
                  <li className="fullWidth">
                    <label>{langJson?.status}</label>
                    {order?.status}
                  </li>
                  <li>
                    <label>{langJson?.subtotal || "Sub Total"}</label>
                    {currency}{" "}
                    {order?.sub_total ?? 0}
                  </li>
                  <li>
                    <label>{langJson?.taxtotal || "Tax Total"}</label>
                    {currency}{" "}
                    {order?.tax_total ?? 0}
                  </li>
                  <li className="fullWidth">
                    <label>{langJson?.total}</label>
                    {currency}{" "}
                    {order?.total_amount ?? 0}
                  </li>
                  <li>
                    <label>{langJson?.paymentstatus}</label>
                    {order?.payment_status}
                  </li>
                  <li>
                    <label>{langJson?.paymentmethod}</label>
                    {order?.payment_method}
                  </li>
                  <li>
                    <label>{langJson?.companyname}</label>
                    {order?.user?.company_name || "-"}
                  </li>
                  <li className="fullWidth">
                    <label>{langJson?.address}</label>
                    {order?.address || "-"}
                  </li>
                  <li>
                    <label>{langJson?.shippingname}</label>
                    {order?.name || "-"}
                  </li>
                  <li className="fullWidth">
                    <label>{langJson?.shippingaddress}</label>
                    {order?.shipping_address}
                  </li>
                </ul>
              </div>

              {/* RIGHT SIDE */}
              <div className="orRgt">
                <div className="orderTbls">
                  <div className="orderMainTbl">
                    <ul>
                      <li>{langJson?.articleno || "Article no"}</li>
                      <li>{langJson?.name || "Name"}</li>
                      <li>{langJson?.size}</li>
                      <li>{langJson?.qty}</li>
                      <li>{langJson?.price} ({currency})</li>
                      <li>Total ({currency})</li>
                    </ul>

                    {(order?.products || []).map((item, index) => {
                      const itemTotal = (item?.price ?? 0) * (item?.quantity ?? 0);
                      return (
                        <ul key={index}>

                          <li>
                            {item?.product?.article_no ? (
                              <a
                                href={`/edit-product/${item?.product?.id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: '#0066cc', cursor: 'pointer', textDecoration: 'none' }}
                              >
                                {item?.product?.article_no}
                              </a>
                            ) : (
                              "-"
                            )}
                          </li>
                          <li>{item?.product?.title || "-"}</li>
                          <li>{item?.size || "-"}</li>
                          <li>{item?.quantity ?? 0}</li>
                          <li>
                            {currency}{" "}
                            {item?.price ?? 0}
                          </li>
                          <li>
                            {currency}{" "}
                            {itemTotal.toFixed(2)}
                          </li>
                        </ul>
                      );
                    })}
                  </div>
                </div>

                {/* TOTALS */}
                <div className="buttonList2">
                  <div className="buttonBox">
                    {langJson?.totalquantity}
                    <strong>
                      {order?.quantity ?? 0} {langJson?.pcs}
                    </strong>
                  </div>
                  <div className="buttonBox">
                    {langJson?.totalprice}
                    <strong>
                      {currency}{" "}
                      {order?.total_amount ?? 0}
                    </strong>
                  </div>
                </div>
              </div>
            </div>
          )}

          {loading && <p>{langJson?.loading || "Loading..."}</p>}
        </div>
      </div>
      <VendorFooter />
    </>
  );
};

export default OrderDetails;
